import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  NumberBox,
  Panel,
  LinkButton,
  Messager,
  ComboBox,
} from "rc-easyui";

import { isEmpty, generateErrorString } from "../../helpers";
import { getCookie, getAccessToken } from "../../helpers/cookieHelper";
import { API_URL } from "../../constants";
import { Button } from "reactstrap";
import PropTypes from "prop-types";

const axios = require("axios");

class AddPricePlan extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
    this.handleSave = this.handleSave.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    // this.handleChange = this.handleChange.bind(this);
  }
  static propTypes = {
    userFields: PropTypes.object,
    validationRules: PropTypes.object,
    isLoading: PropTypes.bool,
    operation: PropTypes.string,
    handleChange: PropTypes.func,
    formClear: PropTypes.func,
    enabled: PropTypes.array,
  };

  handleChange(name, value) {
    this.props.handleChange(name, value);
  }

  handleUpdate() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var form = this.props.userFields;
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(API_URL + "api/priceplan/" + form.id, form, axiosConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        generateErrorString(errors);
      }
    });
  }

  async handleSave() {
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    var form = this.props.userFields;
    form["createdBy"] = getCookie("username");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (access_token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(API_URL + "api/priceplan", form, axiosConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan  Saved Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        generateErrorString(errors);
      }
    });
  }

  render() {
    const user = this.props.userFields;
    const rules = this.props.validationRules;
    const status = this.props.enabled;
    const loading = this.state.isLoading;
    const operation = this.props.operation;
    return (
      <div>
        <div
          className='loadingmodel'
          style={{ display: loading ? "block" : "none" }}
        ></div>
        <Panel title='Create Price Plan' bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <Form
            ref={this.props.innerRef}
            model={user}
            labelWidth={400}
            labelAlign='left'
            rules={rules}
            labelPosition='top'
            onChange={this.handleChange.bind(this)}
          >
            <FormField name='planName' label='Plan Name:'>
              <TextBox
                value={user.planName}
                style={{ width: "100%" }}
              ></TextBox>
            </FormField>

            <FormField
              name='basicInstallationChargeWeb'
              label='Basic Installation Charge(Web):'
            >
              <NumberBox
                value={user.basicInstallationChargeWeb}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField
              name='basicInstallationChargeWebAndMobile'
              label='Basic Installation Charge(Web & Mobile):'
            >
              <NumberBox
                value={user.basicInstallationChargeWebAndMobile}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField
              name='basicRenewChargeWeb'
              label='Basic Renew Charge (Web):'
            >
              <NumberBox
                value={user.basicRenewChargeWeb}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField
              name='basicRenewChargeWebAndMobile'
              label='Basic Renew Charge(Web & Mobile):'
            >
              <NumberBox
                value={user.basicRenewChargeWebAndMobile}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField name='basicMaxUsers' label='Basic Max User:'>
              <NumberBox
                value={user.basicMaxUsers}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField name='perUserRateWeb' label='Per User Rate(Web):'>
              <NumberBox
                value={user.perUserRateWeb}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField
              name='perUserRateWebAndMobile'
              label='Per User Rate(Web & Mobile):'
            >
              <NumberBox
                value={user.perUserRateWebAndMobile}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField name='perScreenRateWeb' label='Per Screen Rate(Web):'>
              <NumberBox
                value={user.perScreenRateWeb}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>

            <FormField
              name='perScreenRateWebAndMobile'
              label='Per Screen Rate(Web & Mobile):'
            >
              <NumberBox
                value={user.perScreenRateWebAndMobile}
                prefix='Rs.'
                precision={2}
                spinners={true}
                style={{ width: "100%" }}
              ></NumberBox>
            </FormField>
            <div
              className='form-field '
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <label
                className='textbox-label f-noshrink'
                htmlFor='form-field-inputid-6'
                style={{ textAlign: "left", width: "100%" }}
              >
                Renew Type:
              </label>
              <br />
              <FormField name='number'>
                <NumberBox
                  name='number'
                  value={user.number}
                  spinners={true}
                  style={{ width: "95%" }}
                  // onChange={(e) => this.handleChange("number", e)}
                ></NumberBox>
              </FormField>

              <FormField name='renewType'>
                <ComboBox
                  data={[
                    { value: "day", text: "Day" },
                    { value: "month", text: "Month" },
                    { value: "year", text: "Year" },
                  ]}
                  value={user.renewType}
                  style={{ width: "100%", height: 20 }}
                  editable={false}
                  // onChange={(e) => this.handleChange("renewType", e)}
                ></ComboBox>
              </FormField>
            </div>
            {/* 
            <FormField name='renewType' label='Renew Type:'>
              <NumberBox style={{ width: "45%" }}></NumberBox>
              <select
                name='transactionType'
                className='custom_input'
                style={{
                  marginLeft: 10,
                  width: "15%",
                  height: 28,
                  background: "white",
                }}
                onChange={(e) =>
                  this.props.handleChange(e.target.name, e.target.value)
                }
              >
                <option
                  value='debit'
                  selected={user.transactionType === "debit" ? "selected" : ""}
                >
                  DR
                </option>
                <option
                  value='credit'
                  selected={user.transactionType === "credit" ? "selected" : ""}
                >
                  CR
                </option>
              </select>
              <ComboBox
                data={[
                  { value: "1-month", text: "1 Month" },
                  { value: "3-month", text: "3 Month" },
                  { value: "4-month", text: "4 Month" },
                  { value: "6-month", text: "6 Month" },
                  { value: "12-month", text: "12 Month" },
                ]}
                value={user.renewType}
                style={{ width: "45%" }}
              ></ComboBox>
            </FormField> */}

            <FormField name='enabled' label='Status:'>
              <ComboBox
                data={status}
                valueField='value'
                textField='text'
                value={user.enabled}
                editable={false}
              ></ComboBox>
            </FormField>

            <hr />
            <div className='text-center'>
              <Button
                color='primary'
                disabled={loading ? true : false}
                onClick={
                  operation === "Add" ? this.handleSave : this.handleUpdate
                }
                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color='danger' onClick={this.props.formClear}>
                Cancel
              </Button>
            </div>
          </Form>
        </Panel>
      </div>
    );
  }
}
export default React.forwardRef((props, ref) => (
  <AddPricePlan innerRef={ref} {...props} />
));

// AddPricePlan.propTypes = {
//   userFields: PropTypes.object,
//   stringProp: PropTypes.string,
//   numberProp: PropTypes.number,
//   boolProp: PropTypes.bool,
// };
